"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const ReviewsSectionHeader = () => {
    return (react_1.default.createElement(styles_1.ReviewsHeader, null,
        react_1.default.createElement(styles_1.ReviewsTitle, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reviewsTitle)))));
};
exports.default = ReviewsSectionHeader;
//# sourceMappingURL=ReviewsSectionHeader.js.map